import { Injectable } from '@angular/core';


import { HttpClient } from '@angular/common/http';
import { GlobalConstants } from '../Constants/global.constants';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class DeviceService {

    constructor(private _http: HttpClient) { }
    getAllfloordevice(request: any): Observable<any> {
        var url = GlobalConstants.API_URL + 'FloorDevice/Filter';
        return this._http.post(url, request);
    }

    adddfloorevice(request: any): Observable<any> {
        var url = GlobalConstants.API_URL + 'FloorDevice/Create';
        return this._http.post(url, request);
    }

    deletefloordevice(request: any): Observable<any> {
        var url = GlobalConstants.API_URL + `FloorDevice/Delete?id=` + request;
        return this._http.delete(url, request);
    }

    updatefloordevice(request: any): Observable<any> {
        var url = GlobalConstants.API_URL + 'FloorDevice/Update?id=' + request.id;
        return this._http.put(url, request);
    }

    getdeviceDropdown(request: any): Observable<any> {
        var url = GlobalConstants.API_URL + 'FloorDevice/GetAllForDropDown';
        return this._http.get(url);
    }


     getAlldevices(request: any): Observable<any> {
        var url = GlobalConstants.API_URL + 'Device/Filter';
        return this._http.post(url, request);
    }


    Createdevice(request: any): Observable<any> {
        var url = GlobalConstants.API_URL + 'Device/Create';
        return this._http.post(url, request);
    }

    updateDevice(request: any): Observable<any> {
        var url = GlobalConstants.API_URL + 'Device/Update?id=' + request.id;
        return this._http.put(url, request);
    }

    deleteDeviceCom(request: any): Observable<any> {
        var url = GlobalConstants.API_URL + `Device/Delete?id=` + request;
        return this._http.delete(url, request);
    }

    getPubSubUrl(id: string, type: 'device' | 'floor'): Observable<any> {

    let queryParam = '';

    if (type === 'device') {
        queryParam = `deviceId=${id}`;
    } else if (type === 'floor') {
        queryParam = `floorId=${id}`;
    }

    const url =
        GlobalConstants.FUNCTION_APP_URL +
        `GetPubSubClientAccessURI?code=${GlobalConstants.Function_APP_KEY}&${queryParam}`;

    console.log('🌐 PubSub API URL:', url);

    return this._http.get(url);
    }

}